import React from 'react';
import Icon from '../shared/Icon.tsx';
import {CirclePlusIcon, EyeIcon} from 'lucide-react';
import {UsersCogIcon} from '../shared/customIcons.ts';
import {UserCollectionType} from '../../api/types.ts';

interface GroupRoleIconProps {
    loggedInUserUserCollectionType?: UserCollectionType | null;
    cssClass?: string;
    showText?: boolean;
}

const GroupRoleIcon: React.FC<GroupRoleIconProps> = ({
    loggedInUserUserCollectionType,
    cssClass,
    showText
}) => {
    const getText = (s: string) => (showText ? s : '');

    return (
        <>
            {loggedInUserUserCollectionType === UserCollectionType.Admin && (
                <span className={cssClass}>
                    <Icon icon={UsersCogIcon} className="text-secondary" />
                    {getText(' Admin')}
                </span>
            )}
            {loggedInUserUserCollectionType ===
                UserCollectionType.Contributor && (
                <span className={cssClass}>
                    <Icon icon={CirclePlusIcon} />
                    {getText(' Contributor')}
                </span>
            )}
            {loggedInUserUserCollectionType === UserCollectionType.Viewer && (
                <span className={cssClass}>
                    <Icon icon={EyeIcon} />
                    {getText(' Viewer')}
                </span>
            )}
        </>
    );
};

export default GroupRoleIcon;
